export const chunk = (arr, size = 10) => {
  const out = []
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size))
  return out
}

// Utility: parse Firestore string/Timestamp into Date
export const toDate = (raw) => {
  if (!raw) return null
  if (raw.toDate) return raw.toDate() // Firestore Timestamp
  if (raw.seconds) return new Date(raw.seconds * 1000)
  if (typeof raw === "string") {
    const normalized = raw.replace(/\s*:\s*/g, ":")
    const d = new Date(normalized)
    return Number.isNaN(d.getTime()) ? null : d
  }
  const d = new Date(raw)
  return Number.isNaN(d.getTime()) ? null : d
}

// Utility: compute age (in years) on a given date (defaults to "now")
export const computeAge = (birth, onDate = new Date()) => {
  if (!birth) return null
  const b = toDate(birth)
  if (!b) return null
  let age = onDate.getFullYear() - b.getFullYear()
  const m = onDate.getMonth() - b.getMonth()
  if (m < 0 || (m === 0 && onDate.getDate() < b.getDate())) {
    age -= 1
  }
  return age
}

// Optional: map UI "male"/"female" to stored "M"/"F"
export const mapSexToGender = (sex) => {
  if (!sex) return null
  if (sex === "male" || sex === "M") return "M"
  if (sex === "female" || sex === "F") return "F"
  return null
}
